import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/hooks/useAdminAuth";

interface ProtectedAdminRouteProps {
  children: ReactNode;
}

export const ProtectedAdminRoute = ({ children }: ProtectedAdminRouteProps) => {
  const { isAdmin, isLoading } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAdmin) {
      // Redirect unauthenticated/non-admin users to the admin login page
      navigate("/admin/login", { replace: true });
    }
  }, [isLoading, isAdmin, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-8">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-primary mx-auto mb-6"></div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">جاري التحقق من الصلاحيات</h2>
          <p className="text-muted-foreground">الرجاء الانتظار...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    // Brief placeholder while redirecting (prevents blank screen flashes)
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">يتم تحويلك إلى صفحة تسجيل الدخول...</h2>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
